import styled from '@emotion/styled';
import { Select } from 'antd';
import tw from 'twin.macro';
import Button from 'components/atoms/Button';
import Loader from 'components/molecules/Loader';
import { CustomModalForSave } from 'components/pages/PromoRecommendation';
import React, { useState } from 'react';
import { calculateFontSize } from 'utils/helperMethods';
import { trackEventMixpanel } from 'utils/mixpanel';
import { PROMO_RECOMMENDATION_NEW_SCENARIO_INPUT_ADDED } from 'utils/mixpanelEventNames';

interface props {
    setSaveScenario: Function;
    onSave: Function;
    saveScenario: any;
    loading?: boolean;
    error?: string;
    title?: string;
    setError?: Function;
}

const CustomSelect = styled(Select)`
    ${tw`rounded text-[13px] text-headerColor`}
    .ant-select-selector {
        height: 100% !important;
        display: flex;
        align-items: center;
        box-shadow: none !important;
        border: none !important;
    }
    .ant-select-arrow {
        ${tw`text-headerColor`}
    }
`;

const ScaleInput = calculateFontSize(window.innerWidth, 200);
function SaveScenarioModal({ setError, setSaveScenario, saveScenario, onSave, loading, error, title }: props) {
    const [text, setText] = useState('');
    const [year, setYear] = useState<string | undefined>(undefined);

    // Generate years from current year to 10 years in the future
    const currentYear = new Date().getFullYear();
    const years = Array.from({ length: 11 }, (_, i) => currentYear + i);

    const handleOk = () => {
        setSaveScenario(false);
    };

    const handleCancel = () => {
        setSaveScenario(false);
    };

    let Footer = () => {
        return (
            <div className="w-full flex justify-end gap-2">
                <Button title={'Cancel'} onClick={() => setSaveScenario(false)} style={{ padding: '0px 20px' }} />
                <Button
                    title={'Save'}
                    onClick={() => {
                        if (!text.trim() || !year) return;
                        onSave({ text: text, year: year });
                    }}
                    theme={'Solid'}
                    style={{ padding: '0px 20px' }}
                />
            </div>
        );
    };

    return (
        <>
            {loading && (
                <div className="fixed inset-0 bg-[#edf0f3] z-[1001] opacity-60">
                    <Loader />
                </div>
            )}
            <CustomModalForSave
                afterClose={() => {
                    setText('');
                    setYear(undefined);
                    if (setError) setError(null);
                }}
                destroyOnClose
                title={title}
                open={saveScenario}
                onOk={handleOk}
                onCancel={handleCancel}
                centered
                width={400}
                footer={Footer()}
            >
                <div className="flex w-full flex-col gap-2 -mt-4">
                    <div className="flex w-full flex-col gap-1">
                        <span className="font-xs font-medium">Name</span>
                        <span className="border border-purpleFont rounded flex">
                            <input
                                className="m-0.5 focus:outline-none w-full text-[13px] opacity-70 pl-[10px]"
                                onChange={(e) => {
                                    setText(e.target.value);
                                    trackEventMixpanel(PROMO_RECOMMENDATION_NEW_SCENARIO_INPUT_ADDED, {
                                        name: e.target.value,
                                    });
                                }}
                                value={text}
                                placeholder="Enter Name"
                            />
                        </span>
                        {error && <p className="text-redTriangle font-xxs font-medium">{error}</p>}
                    </div>
                    <div className="flex w-full flex-col gap-1">
                        <span className="font-xs font-medium">Year</span>
                        <span className="border border-purpleFont rounded flex">
                            <CustomSelect
                                className="m-0.5 focus:outline-none w-full bg-transparent"
                                onChange={(value: unknown) => {
                                    const yearValue = value as string | undefined;
                                    setYear(yearValue);
                                    if (yearValue) {
                                        trackEventMixpanel(PROMO_RECOMMENDATION_NEW_SCENARIO_INPUT_ADDED, {
                                            name: yearValue,
                                        });
                                    }
                                }}
                                placeholder="Select Year"
                                value={year || undefined}
                                options={years.map((yr: number) => ({
                                    label: yr.toString(),
                                    value: yr.toString(),
                                }))}
                            />
                        </span>
                        {error && <p className="text-redTriangle font-xxs font-medium">{error}</p>}
                    </div>
                    {/* <div className="flex w-full flex-col gap-1">
                    <span className="font-xs font-medium">Comment</span>
                    <span className="border border-purpleFont rounded flex">
                        <textarea
                            placeholder="Enter Comment"
                            className="m-1 focus:outline-none"
                            rows={4}
                            cols={50}
                        ></textarea>
                    </span>
                </div> */}
                </div>
            </CustomModalForSave>
        </>
    );
}

export default SaveScenarioModal;
